import { lazy } from 'react';
import AuthRoles from '@/app/auth/authRoles';

const ProviderDetailsPage = lazy(() => import('./ProviderDetailsPage'));

const ProviderDetailsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: AuthRoles.ServiceConfig,
  routes: [
    {
      path: 'providers/:id',
      element: <ProviderDetailsPage />,
    },
  ],
};

export default ProviderDetailsConfig;
